<template>
    <h4>Add order signed contract</h4>
    <div v-if="pageLoading">
      <img class="_imgLoader" src="@/assets/images/loading.gif"/>
    </div>
    <div v-else>
      <div v-if="!isRegisterFormSubmitted">
        <p>
          <input class="formInput" v-model="state.registerForm.accountName" placeholder="document name" /><br>
          <ValidationMessage v-if="v$.registerForm.accountName.$error" :validationMessage ="v$.registerForm.accountName.$errors[0].$message"/>
        </p>
        <p>
          <button class="btn btn-brand-02 btn-block" v-on:click="handleAddDocument">Add document</button>
        </p>
      </div>
      <FeedbackNotification v-if="this.notification.text != ''" 
        :feedbackText="this.notification.text" 
        :feedbackLevel="this.notification.level"/>  
    </div>
  </template>
  
  <script>
  
  import ValidationMessage from "@/components/ValidationMessage.vue";
  import FeedbackNotification from "@/components/FeedbackNotification.vue";
  import { orderAPI } from "@/api/order";
  import { useStatus } from "@/api/composables/status";
  import { useErrorLogger } from "@/api/composables/errorLogging";
  
  import { reactive, computed } from 'vue' 
  import useVuelidate from '@vuelidate/core'
  import { required, email, minLength } from '@vuelidate/validators'
  
  const pageStatus = useStatus();
  const log = useErrorLogger();
  
  export default {
    components : {
      FeedbackNotification, ValidationMessage
    }, 
    setup () {
      const state = reactive({
        registerForm: {
          accountName: "",
        }
      });
      const rules = computed(() => {
        return {
          registerForm: {
            accountName:  { required, minLength: minLength(3) },
          }
        }
      })
      const v$ = useVuelidate(rules, state)
      return { state, v$ }
    },
    data() {
      return {
        pageLoading : false,
        notification : {
          text : "",
          level : "",
        },
        isRegisterFormSubmitted: false
      };
    },
    methods: {
      async handleAddDocument() {
        // validate the form
        this.v$.$validate();
        if(!this.v$.$error)
        {
          this.pageLoading = true;
          const result = await log.catchPromise(() =>
           pageStatus.observe(async () => {
             const result = await orderAPI.addSignedOrderContract(this.state.registerForm.companyName, 
                this.state.registerForm.emailAddress, this.state.registerForm.password.password);
                // success       
                 this.isRegisterFormSubmitted = true;
                 this.notification = { text : "Account Registered.", level : "success" };  
                // notify the parent view  
                 this.$emit('formsubmitted');
              })
          );
          this.pageLoading = false;
          if (!result.success) {
            this.notification = { text : result.data, level : "error" };      
          }
        }
      }
    },
  };
  </script>